import axios from 'axios';
import { getToken } from '../services/auth';
import { BFF_URL } from '../helpers/environment';

// Ensure to import 'https' if necessary, although in most cases, Axios handles this internally.
// import https from 'https';

// Create a base instance of Axios
export const axiosInstance = axios.create({
  baseURL: BFF_URL,
  maxContentLength: Infinity,
  maxBodyLength: Infinity
  // If you need to configure HTTPS agent, you can do it like this:
  // httpsAgent: new https.Agent({
  //   rejectUnauthorized: false
  // })
});

// Add interceptors for authorization headers
axiosInstance.interceptors.request.use(
  config => {
    if (process.env.REACT_APP_USE_AUTH && !config.headers['Authorization']) {
      config.headers['Authorization'] = `Bearer ${getToken()}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);
